var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCompanyWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.99H11V5.99H7V3.99ZM7 9.99H11V7.99H7V9.99ZM7 13.99H11V11.99H7V13.99ZM17 3.99H13V5.99H17V3.99ZM17 7.99H13V9.99H17V7.99ZM17 11.99H13V13.99H17V11.99ZM24 21.99V23.99H0V21.99H2.22L3 18.87V0H21.01V18.88L21.79 22H24.01L24 21.99ZM13 21.99V18.99C13 18.44 12.55 17.99 12 17.99C11.45 17.99 11 18.44 11 18.99V21.99H13ZM15 18.99V21.99H19.73L19 19V2H5L4.97 19.25L4.28 22H9V19C9 17.35 10.35 16 12 16C13.65 16 15 17.35 15 19V18.99Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompanyWhite);
export default __webpack_public_path__ + "static/media/icon-company-white.f40337fb4755ba2ab3304f2915e0f179.svg";
export { ForwardRef as ReactComponent };